import {coreObjectArchiveAction} from 'app-core/platform/archivable/CoreObjectArchiveActions';
import {getUnarchiveAction} from 'archive/ArchiveActionsUtil';
import * as ArchiveModal from 'archive/components/modals/ArchiveModal';
import {FieldDefinitionType} from 'graphql-client/__generated/graphqlGlobalTypes';
import {
  MAX_PARAMETER_DESCRIPTION_LENGTH,
  MAX_PARAMETER_NAME_LENGTH,
} from 'procedures/design/ProcedureDesignConstants';
import {getParameterNameSqlIdentifierErrorMessage} from 'procedures/design/validation/private-validation-helpers/validateParameters';

import {LibraryParameterDefinition, LibraryParameterDefinitionDataType} from '../ParameterLibraryTypes';

/** @package */
export const LIBRARY_PARAMETER_DEFINITION_DATA_TYPE_TO_FRIENDLY_NAME: Record<
  LibraryParameterDefinitionDataType,
  string
> = {
  [FieldDefinitionType.FLOAT]: 'Decimal',
  [FieldDefinitionType.TEXT]: 'Text',
  [FieldDefinitionType.DATETIME]: 'Datetime',
};

export function getParameterNameErrorMessage(name: string, existingNames: Set<string>): string | null {
  if (name.length > MAX_PARAMETER_NAME_LENGTH) {
    return 'Name is too long';
  }

  // TODO (BNCH-133006): Make sure this doesn't give us a false positive with the parameter being updated when we support updates.
  const nameAlreadyInUse = existingNames.has(name);
  if (nameAlreadyInUse) {
    return 'Name already in use';
  }
  return getParameterNameSqlIdentifierErrorMessage(name, 'Parameter');
}

export function getDescriptionErrorMessage(description: string): string | null {
  return description.length > MAX_PARAMETER_DESCRIPTION_LENGTH ? 'Description is too long' : null;
}

export function archiveParameterDefinition(parameterDefinition: LibraryParameterDefinition): void {
  ArchiveModal.open({
    items: [parameterDefinition],
    onArchive: async (itemIds: Array<string>, purpose: string): Promise<void> => {
      await coreObjectArchiveAction(itemIds, purpose);
    },
  });
}

export async function unarchiveParameterDefinition(
  parameterDefinition: LibraryParameterDefinition
): Promise<void> {
  const unarchiveFn = getUnarchiveAction([parameterDefinition.id]);
  await unarchiveFn([parameterDefinition.id]);
}
